var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5436 51.0871C39.6509 51.0871 51.0871 39.6509 51.0871 25.5436C51.0871 11.4362 39.6509 0 25.5436 0C11.4362 0 0 11.4362 0 25.5436C0 39.6509 11.4362 51.0871 25.5436 51.0871Z",
    fill: "#68E05E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.894 25.0846C32.9622 22.6699 33.491 18.2297 31.0764 15.1615C28.6617 12.0933 24.2215 11.5645 21.1533 13.9791C18.0851 16.3938 17.5612 20.829 19.9709 23.8972C20.3151 24.3362 20.7143 24.7354 21.1533 25.0796C17.1222 26.696 14.3084 30.3978 13.8295 34.7133C13.7596 35.3619 14.2286 35.9506 14.8771 36.0204C15.5257 36.0903 16.1144 35.6213 16.1843 34.9727C16.763 29.8042 21.4277 26.0824 26.5963 26.6611C30.9666 27.15 34.414 30.6024 34.9079 34.9727C34.9727 35.5714 35.4816 36.0254 36.0853 36.0204H36.215C36.8586 35.9456 37.3226 35.3669 37.2527 34.7233C36.7738 30.3979 33.945 26.691 29.894 25.0846ZM25.5236 24.2464C22.9244 24.2464 20.814 22.1361 20.814 19.5368C20.814 16.9376 22.9244 14.8273 25.5236 14.8273C28.1229 14.8273 30.2332 16.9376 30.2332 19.5368C30.2332 22.1361 28.1279 24.2464 25.5236 24.2464Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.fbf16f1491f8a68bc4fd85bf51fbf65c.svg";
export { ForwardRef as ReactComponent };